import I18n from "pro-features/components/WithTranslation/src/I18n";
import { i18nFilter } from "app/filters/i18nFilter";
import type { FC, ReactNode } from "react";

export const DataBadgeTooltip: FC<{
    hrefUrl?: string;
    hrefTextKey?: string;
    children: ReactNode;
}> = (props) => {
    const {
        hrefUrl = "https://support.similarweb.com/hc/en-us/articles/4480885168017-Keywords-2-0-Hybrid-Data",
        hrefTextKey = "global.labels.learnMore",
        children,
    } = props;
    const learnMoreLink = `
                <a href=${hrefUrl} target="_blank" >
                    ${i18nFilter()(hrefTextKey)}
                </a>`;
    return (
        <I18n
            dataObj={{ learnMoreLink }}
            dangerouslySetInnerHTML={true}
        >
            {children}
        </I18n>
    );
};
